import React from 'react';
import { isBoolean } from 'helpers/object';

/** @param titles - [1, 3, 5] / ['значение', 'значения', 'значений']  */
export const inflect = (
  val: number,
  titles: string[] = ['значение', 'значения', 'значений'],
  withVal = true,
): string => {
  if (val === null || val === undefined) return '';

  const rounded = Math.floor(val);
  const cases = [2, 0, 1, 1, 1, 2];

  return (
    (withVal ? val + ' ' : '') +
    titles[
      rounded % 100 > 4 && rounded % 100 < 20
        ? 2
        : cases[rounded % 10 < 5 ? rounded % 10 : 5]
    ]
  );
};

export const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
export const stopEvent = (e: React.MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
};

export const booleanToString = (val: boolean | string | undefined): string =>
  (isBoolean(val) ? val : val === 'true') ? 'Да' : 'Нет';

export const generateUid = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const getParentContainer = (triggerNode: HTMLElement) =>
  triggerNode?.parentElement as HTMLElement;

export const getDocumentBody = () => document.body;
